import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubTab from '../SubTab/SubTab';

const FutureWorkExperience1 = () => {
  const category = 'FutureWorkExperience1';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (num) => {
    if (select === num) setSelect(0);
    else setSelect(num);
  };

  const movePage = (path) => {
    navigate(path);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}인재 양성 사업
            </div>
            <div className="banner_main_text">인재 양성 사업</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">인재양성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>

            <div className="navi_box human" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">미래내일일경험(인턴형, 사전직무교육기관)</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  지역산업맞춤형 인력양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/koreanQuickStartProgram')}>
                  한국형 퀵스타트프로그램 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/smeResearchTalentSupport')}>
                  중소기업 연구인력 현장맞춤형 양성지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience1')}>
                  미래내일경험(사전직무교육기관)
                </div>
                <div className="select_row" onClick={() => movePage('/business/FutureWorkExperience2')}>
                  미래내일경험(인턴형)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area temporary">
          <SubTab category={category} />

          {/* 🔹 공통 카드 헤더 */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Future Work Experience</p>
              <h2 className="business-hero-title">미래내일일경험(사전직무교육기관)</h2>
              <p className="business-hero-period">사업기간 : 2025. 3. 1. ~ 2026. 2. 28</p>
            </div>
          </div>

          <div className="sub_main_back">
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>

              {/* ✅ 사업내용: 이미지 대체 섹션 */}
              <div className="fwe1-content">
                <div className="fwe1-top">
                  {/* LEFT card */}
                  <section className="fwe1-left" aria-label="미래내일 일경험 사업 소개">
                    <div className="fwe1-left__header">
                      <div className="fwe1-left__title">미래내일 일경험 사업</div>
                      <button type="button" className="fwe1-left__icon" aria-label="icon">
                        ↻
                      </button>
                    </div>

                    <div className="fwe1-left__quote">
                      “실무를 배우며,
                      <br />
                      내일의 가능성을 키우다”
                    </div>

                    <ul className="fwe1-left__list">
                      <li>미취업자 청년이 직무 중심의</li>
                      <li>실무 경험을 쌓을 수 있도록 돕는</li>
                      <li>청년 취업지원 정책</li>
                    </ul>

                    <ul className="fwe1-left__list fwe1-left__list--muted">
                      <li>청년들이 다양한 일경험 프로그램을</li>
                      <li>통해 진로를 탐색하고 취업을 준비할</li>
                      <li>수 있도록 도움</li>
                    </ul>
                  </section>

                  {/* RIGHT stack */}
                  <div className="fwe1-right" aria-label="추진 배경 및 비전/목표">
                    <section className="fwe1-panel">
                      <h3 className="fwe1-panel__title">추진 배경</h3>
                      <ul className="fwe1-panel__list">
                        <li>
                          기업 채용 경향이 <span className="fwe1-em">수시·경력 중심의 실전형 인재 선호</span>로 변화함에
                          따라 직무 관련 일경험 및 경력 개발에 대한 청년층의 수요 증가
                        </li>
                        <li>
                          청년의 일경험 수요에 비해 양질의 프로그램 부족 및 통합된 정보 체계 부재로{' '}
                          <span className="fwe1-em">일경험 미스매칭(부조화)</span> 지속
                        </li>
                        <li>
                          <span className="fwe1-em">정보 획득 제한 및 불완전 매칭 등으로</span> 일경험 미스매칭(부조화)
                          지속
                        </li>
                      </ul>
                    </section>

                    <section className="fwe1-panel">
                      <h3 className="fwe1-panel__title">미래내일 일경험의 비전과 목표</h3>
                      <ul className="fwe1-panel__list">
                        <li>“미래의 꿈을 만나고, 내일을 준비하는 첫걸음”</li>
                        <li>
                          인턴형, 프로젝트형, ESG 지원형 등 다양한 유형별 지원을 통하여{' '}
                          <span className="fwe1-em">일경험</span> 제공
                        </li>
                        <li>
                          <span className="fwe1-em">일경험 기회</span>를 제공하고{' '}
                          <span className="fwe1-em">원활한 노동시장 진입 촉진</span>을 목표로 함
                        </li>
                      </ul>
                    </section>
                  </div>
                </div>

                {/* bottom formula */}
                <div className="fwe1-bottom" aria-label="프로그램 구성 도식">
                  <div className="fwe1-step">
                    <div className="fwe1-circle fwe1-circle--fill">
                      <div className="fwe1-emoji" aria-hidden="true">
                        📘
                      </div>
                      <div className="fwe1-circle__txt">
                        사전직무교육
                        <br />
                        기초소양 학습
                      </div>
                    </div>
                  </div>

                  <div className="fwe1-op" aria-hidden="true">
                    +
                  </div>

                  <div className="fwe1-step">
                    <div className="fwe1-circle fwe1-circle--fill">
                      <div className="fwe1-emoji" aria-hidden="true">
                        🧾
                      </div>
                      <div className="fwe1-circle__txt">
                        일경험을 통한
                        <br />
                        직무 경험
                      </div>
                    </div>
                  </div>

                  <div className="fwe1-op" aria-hidden="true">
                    =
                  </div>

                  <div className="fwe1-step">
                    <div className="fwe1-circle fwe1-circle--ring">
                      <div className="fwe1-emoji" aria-hidden="true">
                        🏅
                      </div>
                      <div className="fwe1-circle__txt">준비된 인재</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계</div>
              </div>

              <div className="future-work-experience1-img2"></div>

              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">주요직무</div>
              </div>

              <div className="future-work-experience1-img3">
                <div className="job-grid">
                  <div className="job-card">
                    <div className="job-hex hex-1">
                      <span>경영·사무</span>
                    </div>
                    <div className="job-sub chip">세부직무</div>
                    <div className="job-desc">기획, 인사, 행정, 총무, 노무 등</div>
                  </div>

                  <div className="job-card">
                    <div className="job-hex hex-2">
                      <span>연구·R&amp;D</span>
                    </div>
                    <div className="job-sub chip">세부직무</div>
                    <div className="job-desc">경제, 인문·자연과학, 화학, 전기, 원자력, 제약, 바이오, 식품공학 등</div>
                  </div>

                  <div className="job-card">
                    <div className="job-hex hex-3">
                      <span>생산·제조</span>
                    </div>
                    <div className="job-sub chip">세부직무</div>
                    <div className="job-desc">생산·품질관리, 생산, 제조, 전기, 설비, 조립, 가공 등</div>
                  </div>

                  <div className="job-card">
                    <div className="job-hex hex-4">
                      <span>기타직무</span>
                    </div>
                    <div className="job-sub chip">세부직무</div>
                    <div className="job-desc">IT, 관광서비스, 사회복지, 금융회계 등</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureWorkExperience1;
